<template>
    <div>
        <div id="container"></div>
    </div>
</template>
<script>
/* eslint-disable no-undef */
import gsicon from "@/assets/img/icon/map_arrow.png"
let map;
let markers = [];
export default {
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            companies_kind: [],
        }
    },
    watch: {
        list: {
            handler() {
                this.$nextTick(() => {
                    this.companies_kind = [];
                    this.initMap()
                });
            },
            deep: true
        }
    },
    mounted() { },
    methods: {
        initMap() {
            // 如果地图已存在，先销毁
            if (map) {
                map.destroy();
            }
            
            map = new AMap.Map('container', {
                viewMode: '3D',
                zoom: 10,
                center: [120.739366, 31.343302],
                mapStyle: 'amap://styles/normal',
            });

            // 添加比例尺控件
            map.addControl(new AMap.Scale());
            
            // 添加缩放控件
            map.addControl(new AMap.ToolBar());

            // 清除之前的标记
            markers.forEach(marker => {
                map.remove(marker);
            });
            markers = [];

            // 添加公司标记点
            this.list.forEach((e) => {
                // 创建波纹效果的标记
                var marker = new AMap.Marker({
                    position: [e.lng, e.lat],
                    icon: gsicon,
                    offset: new AMap.Pixel(-14, -35),
                    extData: e
                });

                // 添加波纹动画效果（使用自定义HTML）
                var rippleMarker = new AMap.Marker({
                    position: [e.lng, e.lat],
                    content: '<div class="ripple-marker"><div class="ripple"></div></div>',
                    offset: new AMap.Pixel(-12, -12),
                });

                markers.push(marker);
                markers.push(rippleMarker);
                map.add([marker, rippleMarker]);
            });

            // 添加中心点标记（苏州）
            var centerMarker = new AMap.Marker({
                position: [120.739366, 31.343302],
                icon: gsicon,
                offset: new AMap.Pixel(-14, -35),
            });

            var centerRipple = new AMap.Marker({
                position: [120.739366, 31.343302],
                content: '<div class="ripple-marker"><div class="ripple"></div></div>',
                offset: new AMap.Pixel(-12, -12),
            });

            markers.push(centerMarker);
            markers.push(centerRipple);
            map.add([centerMarker, centerRipple]);

            //阻止和swiper事件冲突
            document.querySelector('#container').onmousewheel = e => {
                e = e || window.event;
                e.stopPropagation();
            }
        },
        mapFly(data) {
            if (map) {
                map.setZoomAndCenter(12, [data.lng, data.lat]);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
#container {
    width: 100%;
    height: 42.9rem;
}

// 波纹动画样式
::v-deep .ripple-marker {
    position: relative;
    width: 24px;
    height: 24px;
    
    .ripple {
        position: absolute;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: rgba(52, 144, 238, 0.6);
        animation: ripple-animation 2s infinite;
    }
}

@keyframes ripple-animation {
    0% {
        transform: scale(0.5);
        opacity: 1;
    }
    100% {
        transform: scale(2);
        opacity: 0;
    }
}

// 隐藏地图左下版权
::v-deep .amap-logo,
::v-deep .amap-copyright {
    display: none !important;
}
</style>